import { render } from "./DeliveryTypeTable.vue?vue&type=template&id=f8e41c62"
import script from "./DeliveryTypeTable.vue?vue&type=script&lang=js"
export * from "./DeliveryTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__